(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[294],{

/***/ "LWMV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrowDown", function() { return ArrowDown; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var ArrowDown = function ArrowDown(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M16.4135055,21.4189896 C16.0391321,21.794715 15.5400357,22 15.0120627,22 C14.4791745,22 13.9823309,21.794715 13.6079575,21.4189896 L3.58320747,11.390289 C3.20641739,11.0145637 3,10.5175788 3,9.98555012 C3,9.4559108 3.20641739,8.95653658 3.58320747,8.58320059 C3.95760139,8.20767437 4.45440396,8 4.98712835,8 C5.5151014,8 6.01440252,8.20767437 6.38877596,8.58320059 L15.0120627,17.2097508 L23.632687,8.58320059 C24.0070605,8.20767437 24.5063616,8 25.0367922,8 C25.5647653,8 26.0638616,8.20767437 26.4384398,8.58320059 C27.1871867,9.33226192 27.1871867,10.6390374 26.4384398,11.390289 L16.4135055,21.4189896 Z"
  }));
};

/***/ })

}]);